import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'

import { formatTime } from 'utils'

export class EventDetails extends React.Component {
  render() {
    const { event, locale } = this.props

    const priceMode = event.prices.length > 1
      ? 'from'
      : event.price.mode
    const priceValue = event.prices[0] || event.price.value

    return (
      <div className="event-details">
        <div
          className="event-details__row"
          style={{ display: event.hideDuration ? 'none' : '' }}
        >
          <div className="event-details__label">
            <FormattedMessage id="app.event.details.duration" />
          </div>
          <div className="event-details__value">
            { formatTime(event.duration) }
          </div>
        </div>
        <div
          className="event-details__row"
          style={{ display: event.hidePrice ? 'none' : '' }}
        >
          <div className="event-details__label">
            <FormattedMessage id="app.event.details.price" />
          </div>
          <div className="event-details__value">
            <FormattedMessage
              id={`app.cellar.event.price.${priceMode}${event.default_product_singular ? '.custom' : ''}`}
              values={{
                amount: priceValue,
                currency: event.location.currency,
                customText: event.default_product_singular,
              }}
            />
          </div>
        </div>
        <div className="event-details__expense">
          {
            event.expense.is_set &&
            <FormattedMessage
              id="app.event.details.expense"
              values={{ amount: event.expense.value, currency: event.location.currency }}
            />
          }
        </div>
        <div className="event-details__actions">
          <div className="event-details__cta">
            <a href="#reservation" className="event-details__cta button--primary button--small">
              <FormattedMessage
                id={ `app.event.cta.${event.reservationMode === 'view' ? 'infos' : 'book'}` }
              />
            </a>
          </div>
          <div className="event-details__back">
            <Link
              to={`/${locale}/${event.cellar._id}?lang=${event.language}`}
              className="button--secondary button--small"
            >
              <FormattedMessage id="app.event.back" />
            </Link>
          </div>
        </div>
      </div>
    )
  }
}

EventDetails.propTypes = {
  event: PropTypes.object.isRequired,
  locale: PropTypes.string.isRequired,
}

export default EventDetails
